<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" :loading="loading"/>

    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('emvSuccessPaymentsSummaryReport.title') }}</h2>
      <p class="text-center mb-3 no-print">
        {{ $t('emvSuccessPaymentsSummaryReport.description') }}
      </p>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && !error && reportEnvelope" class="row">
      <div class="col-6">
        <card :title="$t('emvSuccessPaymentsSummaryReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('generic.reportGeneratedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.generatedAt | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('generic.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.periodFrom | dateOnly }} - {{
                  reportEnvelope.periodTo | dateOnly
                }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('emvSuccessPaymentsSummaryReport.summary.totalSumAmount') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.totalSumAmount | money }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>


    <div v-if="loading === false && !error && reportData" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`emvSuccessPaymentsSummaryReport.tableTitle`) }}<small
            v-if="reportEnvelope"
            class="ml-2 text-muted">({{
              reportEnvelope.periodFrom | dateOnly
            }} - {{ reportEnvelope.periodTo | dateOnly }})</small>
          </h4>
          <div>
            <el-table :data="reportData"
                      :empty-text="$t('generic.emptyReportForThePeriod')">
              <el-table-column :label="$t('emvSuccessPaymentsSummaryReport.table.day')">
                <template slot-scope="{ row }">{{ row.day | dateOnly }}</template>
              </el-table-column>
              <el-table-column :label="$t('emvSuccessPaymentsSummaryReport.table.amount_sum')">
                <template slot-scope="{ row }">{{ row.amount_sum | money }}</template>
              </el-table-column>
            </el-table>
          </div>

        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert} from 'src/components';
import {mapActions, mapState} from "vuex";
import DetailedReportPeriod from 'src/components/DetailedReportPeriod/DetailedReportPeriod';
import ReportFilter from "./ReportFilter";

export default {
  name: 'emvSuccessPaymentsSummaryReport',
  components: {
    BaseAlert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    DetailedReportPeriod,
    ReportFilter
  },
  data() {
    return {
      report: null, // Received report data.
      reportEnvelope: null,
      reportData: [],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.emv_success_payments_summary_report.loading,
      error: state => state.emv_success_payments_summary_report.error,
      data: state => state.emv_success_payments_summary_report.data,
    }),
  },
  methods: {
    ...mapActions(['LoadEmvSuccessPaymentsSummaryReport']),
    reloadReport(query) {
      this.LoadEmvSuccessPaymentsSummaryReport(query);
    },
    prepareReportData(report) {
      if (report == null) {
        this.reportData = null;
        this.reportEnvelope = null;
        return
      }

      this.reportEnvelope = {
        totalSumAmount: 0,
        totalJourneysCount: 0,
        periodFrom: report.from,
        periodTo: report.to,
        generatedAt: report.generated_at,
      }

      this.reportData = report.data.amount_summary_per_day

      this.reportEnvelope.totalSumAmount = this.reportData.reduce((r, d) => r + d.amount_sum, 0);
    }
  },
  mounted() {
    this.prepareReportData(this.data)
  },
  watch: {
    data(data) {
      this.prepareReportData(data)
    }
  }
};
</script>

